var map = {
	"./1864.png": 4377,
	"./1864_dark.png": 6562,
	"./1865.png": 7472,
	"./1865_dark.png": 9785,
	"./1866.png": 7323,
	"./1866_dark.png": 6924,
	"./1867.png": 6194,
	"./1867_dark.png": 1819,
	"./1868.png": 6789,
	"./1868_dark.png": 3478,
	"./1869.png": 3724,
	"./1869_dark.png": 4173,
	"./1870.png": 5730,
	"./1870_dark.png": 5035,
	"./1871.png": 4731,
	"./1871_dark.png": 5884,
	"./1872.png": 9696,
	"./1872_dark.png": 4057,
	"./1873.png": 873,
	"./1873_dark.png": 8162,
	"./1874.png": 6614,
	"./1874_dark.png": 2759,
	"./1875.png": 8351,
	"./1875_dark.png": 8888,
	"./1876.png": 4788,
	"./1876_dark.png": 2917,
	"./1877.png": 7293,
	"./1877_dark.png": 4350,
	"./1878.png": 3434,
	"./1878_dark.png": 4195,
	"./1879.png": 5011,
	"./1879_dark.png": 2452,
	"./1880.png": 9927,
	"./1880_dark.png": 6640,
	"./1881.png": 702,
	"./1881_dark.png": 5343,
	"./1882.png": 4709,
	"./1882_dark.png": 7910,
	"./1883.png": 1820,
	"./1883_dark.png": 5245,
	"./1884.png": 3043,
	"./1884_dark.png": 3876,
	"./1885.png": 7834,
	"./1885_dark.png": 8419,
	"./1886.png": 8417,
	"./1886_dark.png": 3706,
	"./1887.png": 936,
	"./1887_dark.png": 4305,
	"./1888.png": 2239,
	"./1888_dark.png": 5576,
	"./1889.png": 3222,
	"./1889_dark.png": 3031,
	"./1890.png": 6956,
	"./1890_dark.png": 5293,
	"./1891.png": 8581,
	"./1891_dark.png": 1462,
	"./1892.png": 1854,
	"./1892_dark.png": 2511,
	"./1893.png": 7639,
	"./1893_dark.png": 1600,
	"./1894.png": 8024,
	"./1894_dark.png": 1825,
	"./1895.png": 6417,
	"./1895_dark.png": 4090,
	"./1896.png": 170,
	"./1896_dark.png": 4387,
	"./1897.png": 6355,
	"./1897_dark.png": 2132,
	"./1898.png": 6164,
	"./1898_dark.png": 9125,
	"./1899.png": 9405,
	"./1899_dark.png": 8478,
	"./1900.png": 2686,
	"./1900_dark.png": 7871,
	"./1901.png": 4023,
	"./1901_dark.png": 4240,
	"./1902.png": 5548,
	"./1902_dark.png": 413,
	"./1903.png": 8437,
	"./1903_dark.png": 6086,
	"./1904.png": 4138,
	"./1904_dark.png": 8115,
	"./1905.png": 5715,
	"./1905_dark.png": 20,
	"./1906.png": 8856,
	"./1906_dark.png": 609,
	"./1907.png": 8801,
	"./1907_dark.png": 1418,
	"./1908.png": 7318,
	"./1908_dark.png": 6679,
	"./1909.png": 5407,
	"./1909_dark.png": 6456,
	"./1910.png": 5081,
	"./1910_dark.png": 4130,
	"./1911.png": 8176,
	"./1911_dark.png": 7353,
	"./1912.png": 8027,
	"./1912_dark.png": 4492,
	"./1913.png": 6898,
	"./1913_dark.png": 9387,
	"./1914.png": 3245,
	"./1914_dark.png": 3966,
	"./1915.png": 2116,
	"./1915_dark.png": 7013,
	"./1916.png": 1023,
	"./1916_dark.png": 3800,
	"./1917.png": 2006,
	"./1917_dark.png": 7143,
	"./1918.png": 8161,
	"./1918_dark.png": 6730,
	"./1919.png": 3544,
	"./1919_dark.png": 6753,
	"./1920.png": 6132,
	"./1920_dark.png": 8245,
	"./1921.png": 6077,
	"./1921_dark.png": 2126,
	"./1922.png": 4454,
	"./1922_dark.png": 4807,
	"./1923.png": 783,
	"./1923_dark.png": 6280,
	"./1924.png": 9456,
	"./1924_dark.png": 4265,
	"./1925.png": 4281,
	"./1925_dark.png": 7698,
	"./1926.png": 3570,
	"./1926_dark.png": 5675,
	"./1927.png": 7787,
	"./1927_dark.png": 4188,
	"./1928.png": 3628,
	"./1928_dark.png": 6141,
	"./1929.png": 2725,
	"./1929_dark.png": 5126,
	"./1930.png": 8911,
	"./1930_dark.png": 920,
	"./1931.png": 7366,
	"./1931_dark.png": 7495,
	"./1932.png": 4925,
	"./1932_dark.png": 1758,
	"./1933.png": 7444,
	"./1933_dark.png": 8597,
	"./1934.png": 3707,
	"./1934_dark.png": 3676,
	"./1935.png": 3202,
	"./1935_dark.png": 59,
	"./1936.png": 2166,
	"./1936_dark.png": 8514,
	"./1937.png": 3536,
	"./1937_dark.png": 6697,
	"./1938.png": 9895,
	"./1938_dark.png": 4288,
	"./1939.png": 6750,
	"./1939_dark.png": 7023,
	"./1940.png": 3538,
	"./1940_dark.png": 7707,
	"./1941.png": 4043,
	"./1941_dark.png": 7676,
	"./1942.png": 3872,
	"./1942_dark.png": 697,
	"./1943.png": 121,
	"./1943_dark.png": 2514,
	"./1944.png": 7702,
	"./1944_dark.png": 1495,
	"./1945.png": 9247,
	"./1945_dark.png": 8568,
	"./1946.png": 7780,
	"./1946_dark.png": 6245,
	"./1947.png": 5261,
	"./1947_dark.png": 9406,
	"./1948.png": 8138,
	"./1948_dark.png": 1491,
	"./1949.png": 51,
	"./1949_dark.png": 4420,
	"./1950.png": 5069,
	"./1950_dark.png": 5742,
	"./1951.png": 1172,
	"./1951_dark.png": 261,
	"./1952.png": 8031,
	"./1952_dark.png": 2360,
	"./1953.png": 1094,
	"./1953_dark.png": 6055,
	"./1954.png": 1177,
	"./1954_dark.png": 1554,
	"./1955.png": 3056,
	"./1955_dark.png": 4473,
	"./1956.png": 7416,
	"./1956_dark.png": 2156,
	"./1957.png": 210,
	"./1957_dark.png": 5931,
	"./1958.png": 7413,
	"./1958_dark.png": 9462,
	"./1959.png": 5148,
	"./1959_dark.png": 4141,
	"./1960.png": 5080,
	"./1960_dark.png": 9393,
	"./1961.png": 7121,
	"./1961_dark.png": 8010,
	"./1962.png": 7226,
	"./1962_dark.png": 1955,
	"./1963.png": 7059,
	"./1963_dark.png": 9700,
	"./1964.png": 7660,
	"./1964_dark.png": 2861,
	"./1965.png": 9285,
	"./1965_dark.png": 9030,
	"./1966.png": 2558,
	"./1966_dark.png": 79,
	"./1967.png": 4695,
	"./1967_dark.png": 5520,
	"./1968.png": 4112,
	"./1968_dark.png": 1785,
	"./1969.png": 8313,
	"./1969_dark.png": 8594,
	"./1970.png": 3747,
	"./1970_dark.png": 7796,
	"./1971.png": 8538,
	"./1971_dark.png": 5987,
	"./1972.png": 9121,
	"./1972_dark.png": 7626,
	"./1973.png": 7992,
	"./1973_dark.png": 1873,
	"./1974.png": 631,
	"./1974_dark.png": 4208,
	"./1975.png": 1406,
	"./1975_dark.png": 9263,
	"./1976.png": 5413,
	"./1976_dark.png": 5478,
	"./1977.png": 8876,
	"./1977_dark.png": 2813,
	"./1978.png": 8363,
	"./1978_dark.png": 6540,
	"./1979.png": 7234,
	"./1979_dark.png": 2059,
	"./1980.png": 8713,
	"./1980_dark.png": 5559,
	"./1981.png": 4895,
	"./1981_dark.png": 9304,
	"./1982.png": 9620,
	"./1982_dark.png": 9397,
	"./1983.png": 5242,
	"./1983_dark.png": 5102,
	"./1984.png": 2882,
	"./1984_dark.png": 5803,
	"./1985.png": 4427,
	"./1985_dark.png": 4159,
	"./1986.png": 6864,
	"./1986_dark.png": 4489,
	"./1987.png": 1065,
	"./1987_dark.png": 1298,
	"./1988.png": 5310,
	"./1988_dark.png": 9135,
	"./1989.png": 7447,
	"./1989_dark.png": 8224,
	"./1990.png": 9137,
	"./1990_dark.png": 9066,
	"./1991.png": 9192,
	"./1991_dark.png": 8257,
	"./1992.png": 6051,
	"./1992_dark.png": 4020,
	"./1993.png": 4474,
	"./1993_dark.png": 5763,
	"./1994.png": 8773,
	"./1994_dark.png": 3734,
	"./1995.png": 3503,
	"./1995_dark.png": 4413,
	"./1996.png": 4359,
	"./1996_dark.png": 1888,
	"./1997.png": 3022,
	"./1997_dark.png": 1871,
	"./1998.png": 1913,
	"./1998_dark.png": 9730,
	"./1999.png": 736,
	"./1999_dark.png": 5625,
	"./2000.png": 7422,
	"./2000_dark.png": 1644,
	"./2001.png": 9911,
	"./2001_dark.png": 6304,
	"./2002.png": 7260,
	"./2002_dark.png": 3373,
	"./2003.png": 3173,
	"./2003_dark.png": 5046,
	"./2004.png": 9402,
	"./2004_dark.png": 3251,
	"./2005.png": 3507,
	"./2005_dark.png": 1860,
	"./2006.png": 296,
	"./2006_dark.png": 6961,
	"./2007.png": 513,
	"./2007_dark.png": 5706,
	"./2008.png": 3206,
	"./2008_dark.png": 1639,
	"./2009.png": 143,
	"./2009_dark.png": 7944,
	"./2010.png": 6169,
	"./2010_dark.png": 9042,
	"./2011.png": 416,
	"./2011_dark.png": 4361,
	"./2012.png": 5819,
	"./2012_dark.png": 8156,
	"./2013.png": 2162,
	"./2013_dark.png": 7499,
	"./2014.png": 4957,
	"./2014_dark.png": 9473,
	"./2015.png": 3828,
	"./2015_dark.png": 5301,
	"./2016.png": 6287,
	"./2016_dark.png": 408,
	"./2017.png": 1190,
	"./2017_dark.png": 4151,
	"./2018.png": 7345,
	"./2018_dark.png": 8938,
	"./2019.png": 4632,
	"./2019_dark.png": 9233,
	"./2020.png": 1396,
	"./2020_dark.png": 981,
	"./2021.png": 4637,
	"./2021_dark.png": 334,
	"./2022.png": 2870,
	"./2022_dark.png": 9524,
	"./2023.png": 6671,
	"./2023_dark.png": 888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4991;